import {
  filterAdoverlayData,
  formatAdoverlayData,
} from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { DateStr, Station, toDateRange, today, toTimestamp } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { AdOverlayForm } from './AdOverlayForm';
import { AdOverlayList } from './AdOverlayList';
import { AdOverlayListing } from './types';
import SortContext from '../../context';
import { useState } from 'react';
import { MRT_SortingState } from 'material-react-table';

type Props = {
  station: Station;
};

export function AdOverlayView(p: Props) {
  const tz = useTimezone();
  const [sort, setSort] = useState<MRT_SortingState>([]);

  return (
    <SortContext.Provider value={{ sort, setSort }}>
      <ReportView<AdOverlayListing>
        runOnLoad
        defaultValues={{
          ...toDateRange(today() as DateStr, tz),
        }}
        sort={sort && sort.length > 0 ? { id: sort[0].id, desc: sort[0].desc } : undefined}
        download={false}
        reportFn={(values) =>
          apiClient.audit
            .fetchAdoverlayRange(
              p.station.slug,
              {
                from: toTimestamp(values.from),
                to: toTimestamp(values.to),
              },
              true,
              sort && sort.length > 0 ? [{ id: sort[0].id, desc: sort[0].desc }] : undefined,
            )
            .then((res) => {
              const adoverlays = formatAdoverlayData(filterAdoverlayData(res));
              if (adoverlays.length === 0) {
                return {
                  results: [],
                  total: 0,
                };
              }

              return {
                results: adoverlays,
                total: adoverlays.length,
              };
            })
        }
        Form={AdOverlayForm}
        Result={AdOverlayList}
      />
    </SortContext.Provider>
  );
}
